"use client";

import React from "react";
import { ShoppingBag, ClipboardCheck, Package, Truck } from "lucide-react";
import { Card, CardHeader, CardTitle, CardDescription, CardContent } from "@/components/ui/card";
import { useRevealOnScroll } from "@/hooks/useRevealOnScroll";
const stages = [{
  id: 1,
  title: "Nuestra Fundación",
  description: "Kalisch Acero nació con la visión de transformar la industria del acero, estableciendo cimientos sólidos basados en la integridad y la excelencia operativa desde el primer día.",
  icon: ShoppingBag
}, {
  id: 2,
  title: "Expansión Industrial",
  description: "Crecimos estratégicamente para convertirnos en líderes del mercado, integrando procesos de vanguardia y ampliando nuestra capacidad para servir a los sectores más exigentes.",
  icon: ClipboardCheck
}, {
  id: 3,
  title: "Compromiso de Calidad",
  description: "Implementamos estándares internacionales de control, asegurando que cada producto de acero que sale de nuestras plantas cumpla con las especificaciones técnicas más rigurosas.",
  icon: Package
}, {
  id: 4,
  title: "Futuro Sostenible",
  description: "Hoy lideramos el camino hacia una industria más limpia, invirtiendo en tecnologías de reciclaje y procesos de bajo impacto ambiental para las próximas generaciones.",
  icon: Truck
}];
function TimelineStage({
  stage,
  index,
  isEven
}: {
  stage: typeof stages[0];
  index: number;
  isEven: boolean;
}) {
  const {
    ref,
    isVisible
  } = useRevealOnScroll({
    threshold: 0.3
  });
  const Icon = stage.icon;
  return <div ref={ref} data-index={index} className="relative flex w-full flex-col items-start md:flex-row md:items-center md:justify-between">
      {}
      <div className={`absolute left-8 z-10 flex h-12 w-12 -translate-x-1/2 items-center justify-center rounded-lg bg-background border-4 shadow-md transition-colors duration-700 md:left-1/2 ${isVisible ? "border-primary" : "border-border"}`}>
        <Icon className={`h-5 w-5 transition-colors duration-700 ${isVisible ? "text-accent" : "text-muted-foreground"}`} />
      </div>

      {}
      <div className={`w-full pl-24 transition-all duration-700 md:w-[45%] md:pl-0 ${isEven ? "md:mr-auto md:pr-16 md:text-right" : "md:ml-auto md:pl-16 md:text-left"} ${isVisible ? "translate-y-0 opacity-100" : "translate-y-8 opacity-0"}`}>
        <Card className="border-border/50 shadow-md transition-shadow duration-300 hover:shadow-lg">
          <CardHeader className={`pb-2 ${isEven ? "md:items-end" : "md:items-start"}`}>
            <CardTitle className="font-default text-xl font-bold text-foreground">{stage.title}</CardTitle>
          </CardHeader>
          <CardContent>
            <CardDescription className="font-default text-base text-muted-foreground">
              {stage.description}
            </CardDescription>
          </CardContent>
        </Card>
      </div>
    </div>;
}
export default function AboutUsCopy() {
  const {
    ref: sectionRef,
    isVisible: sectionVisible
  } = useRevealOnScroll({
    threshold: 0.1
  });
  return;
}